import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import timeoutsStore from './../../stores/timeouts';
import { Keyframes } from './Keyframes';
import sessionStore from './../../stores/session';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import newTracksStore from './../../stores/newTracks';
import accountStore from '../../stores/account';
import testStore from '../../stores/test';
import settingsStore from '../../stores/settings';

function MarqueeBarPlayer(props) {

  const currentTime = playerStore((state) => state.currentTime);

  const [isAnimating, setIsAnimating] = useState(false);
  const [nowPlaying, setNowPlaying] = useState(true);
  const [marquee, setMarquee] = useState(false);
  const [home, setHome] = useState(false);

  const timeoutNowPlaying = () => {
    if (timeoutsStore.getState().timerPlayingNow) {
      clearTimeout(timeoutsStore.getState().timerPlayingNow);
    }
    let timeout = setTimeout(function () {
      setNowPlaying(false);
      setMarquee(true);
      setHome(false);
      timeoutMarquee();
    }, 3000);
    timeoutsStore.getState().setTimerPlayingNow(timeout);
  };

  const timeoutMarquee = () => {
    if (timeoutsStore.getState().timerMarquee) {
      clearTimeout(timeoutsStore.getState().timerMarquee);
    }
    let timeout = setTimeout(function () {
      setMarquee(false);
      if (timeoutsStore.getState().sequenceCount == 3 && !props.isCustomer) {
        setHome(true);
        setNowPlaying(false);
        timeoutsStore.getState().setSequenceCount(0);
        timeoutHome();
      } else {
        setHome(false);
        setNowPlaying(true);
        if (!props.isCustomer) timeoutsStore.getState().setSequenceCount(timeoutsStore.getState().sequenceCount + 1);
        timeoutNowPlaying();
      }
    }, timeoutsStore.getState().timerMarqueeSecs * 1000);
    timeoutsStore.getState().setTimerMarquee(timeout);
  };

  const timeoutHome = () => {
    if (timeoutsStore.getState().timerHome) {
      clearTimeout(timeoutsStore.getState().timerHome);
    }
    let timeout = setTimeout(function () {
      setNowPlaying(true);
      setMarquee(false);
      setHome(false);
      timeoutNowPlaying();
    }, 2000);
    timeoutsStore.getState().setTimerHome(timeout);
  };

  const calcMarqueeSecs = (length) => {
    return Math.max(5, length / 58 * 5);
  };

  const beginTimer = () => {
    if (timeoutsStore.getState().timerPlayingNow) {
      clearTimeout(timeoutsStore.getState().timerPlayingNow);
    }
    if (timeoutsStore.getState().timerMarquee) {
      clearTimeout(timeoutsStore.getState().timerMarquee);
    }
    if (timeoutsStore.getState().timerHome) {
      clearTimeout(timeoutsStore.getState().timerHome);
    }
    setNowPlaying(true);
    setMarquee(false);
    setHome(false);
    timeoutsStore.getState().setSequenceCount(0);
    timeoutsStore.getState().setPlayQueueStr(props.playQueueTrackList);
    let calcSecs = calcMarqueeSecs(props.playQueueTrackList.length);
    timeoutsStore.getState().setTimerMarqueeSecs(calcSecs);
    timeoutNowPlaying();
    setIsAnimating(true);
  };

  useEffect(function () {
    if (!isAnimating) {
      beginTimer();
    }
  }, []);

  useEffect(function () {
    if (props.currentTitle) {
      beginTimer();
    }
  }, [props.currentTitle]);

  useEffect(function () {
    if (props.isCustomer) {
      beginTimer();
    }
  }, [props.isCustomer]);

  useEffect(function () {
    if (props.nextSinger) {
      beginTimer();
    }
  }, [props.nextSinger]);

  useEffect(function () {
    if (props.playQueueTrackList) {
      timeoutsStore.getState().setPlayQueueStr(props.playQueueTrackList);
      let calcSecs = calcMarqueeSecs(props.playQueueTrackList.length);
      timeoutsStore.getState().setTimerMarqueeSecs(calcSecs);
    }
  }, [props.playQueueTrackList]);

  const render = () => {
    if (isAnimating) {
      if (props.numSingers > 0) {
        if (props.trackLength - currentTime <= 30) {
          return <div>
            <p className="fadeinout" style={{ width: "100%", textAlign: "center" }}>
              <span style={{ width: "100%" }}>
                {props.nextSinger}
              </span>
            </p>
          </div>;
        } else {
          return <div style={{ width: "100%", overflow: "hidden" }}>
            <p className="fadeinout" style={{ display: nowPlaying ? "block" : "none", textAlign: "center", color: "white", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 2.8s ease-out forwards" }}>
              <span>
                {props.currentTitle} {props.countdown > 0 ? props.countdown+"s" : ""}
              </span>
            </p>
            <p className="fadeinout" style={{ display: home ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 1.8s ease-out forwards" }}>
              <span>
                {TR.cm_sing_at_home_too}
              </span>
            </p>
            <Keyframes name="marquee-list" from={{ transform: "translate(0%, 0)" }} to={{ transform: "translate(min(0px, calc(100vw - " + (timeoutsStore.getState().playQueueStr.length * 1.85) + "vh)), 0)" }} />
            <p className="marquee" style={{ minWidth: "100%", margin: "0px", width: (timeoutsStore.getState().playQueueStr.length * 1.8) + "vh", display: marquee ? "block" : "none", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s " + (timeoutsStore.getState().timerMarqueeSecs - 0.2) + "s ease-out forwards" }}>
              <span style={{ width: "100%", animation: "marquee-list " + ((timeoutsStore.getState().timerMarqueeSecs - 3)) + "s cubic-bezier(0.3,0.05,0.8,0.95) 2s forwards" }}>
                {timeoutsStore.getState().playQueueStr}
              </span>
            </p>
          </div>;
        }
      } else {
        if (props.isStopped && !props.isOnAutoPlay) {
          return <div style={{ width: "100%", overflow: "hidden" }}>
            <p className="fadeinout" style={{ display: home ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 1.8s ease-out forwards" }}>
              <span>
                {TR.cm_sing_at_home_too}
              </span>
            </p>
          </div>;
        } else {
          return <div style={{ width: "100%", overflow: "hidden" }}>
            <p className="fadeinout" style={{ display: nowPlaying ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 2.8s ease-out forwards" }}>
              <span>
                {props.currentTitle} {props.countdown > 0 ? props.countdown+"s" : ""}
              </span>
            </p>
            <p className="fadeinout" style={{ display: home ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 1.8s ease-out forwards" }}>
              <span>
                {TR.cm_sing_at_home_too}
              </span>
            </p>
          </div>;
        }
      }
    }
  };

  return (
    <div id="muvika-marquee-top-bar" style={{ width: "100%", height: "6vh", fontSize: "4vh !important" }}>
      {render()}
    </div>
  );
}

export default MarqueeBarPlayer;
